<template>
  <b-button
    :to="route"
    :class="{'ks-card-sm': small}"
    class="ks-card p-3 m-2 bg-white d-flex flex-column justify-content-center"
  >
    <div class="ks-card-icon-container">
      <img
        :src="imageSource"
        :alt="text"
        v-if="imageSource"
      >
      <icon-base
        :title="text"
        width="50"
        height="50"
        color="#003064"
        role="img"
        class="card-icon mx-auto"
        v-if="icon"
      >
        <component :is="'icon-' + icon" />
      </icon-base>
    </div>
    <span class="ks-card-text">{{ text }}</span>
  </b-button>
</template>

<script>
export default {
  name: 'Card',
  props: {
    route: {
      type: String,
      default: ''
    },
    text: {
      type: String,
      default: ''
    },
    imageSource: {
      type: String,
      default: ''
    },
    placement: {
      type: String,
      default: 'left'
    },
    icon: {
      type: String,
      default: ''
    },
    small: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="scss" scoped>
.ks-card-text {
  font-weight: 500;
  color: $primary;
}
img, .card-icon {
  height: 100%;
}
.ks-card-icon-container {
  height: 60%;
}

.ks-card {
  width: 150px;
  height: 110px;
  border-radius: 7px;
}
.ks-card-sm {
  height: 80px !important;
}
#living-images-card {
  width: 316px;
  height: 66px;
  border-radius: 7px;
}
.li-text-box {
  font-weight: 500;
  color: $primary !important;
}
#living-images-icon {
  height: 100%;
}

@media (min-width: $breakpoint-md) {
  .ks-card {
    width: 200px;
  }
}
@media (max-width: 340px) {
  .ks-card {
    width: 40%;
  }
  #living-images-card {
    width: 86%;
  }
}
</style>
